import styled from "styled-components";

/**
 * Componente ContainerResultsFlights
 *
 * Container principal para os resultados de voos.
 */
export const ContainerResultsFlights = styled.div`
  flex-direction: column;
  display: flex;
`;

/**
 * Componente StyledResultsHeader
 *
 * Container para o cabeçalho dos resultados de voos.
 */
export const StyledResultsHeader = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "isMobile",
})<{ isMobile?: boolean }>`
  padding-bottom: ${({ theme }) => theme.spacing(5)};
  gap: ${({ theme, isMobile }) => (isMobile ? 0 : theme.spacing(4))};
  align-items: end;
  display: ${({ isMobile }) => (isMobile ? "flex" : "grid")};
  grid-template-columns: ${({ isMobile }) =>
    isMobile ? "none" : "minmax(0, 0.75fr) minmax(0, 2fr) 300px"};

  & > *:last-child {
    width: ${({ isMobile }) => (isMobile ? "100%" : "calc(100% - 150px)")};
    min-width: 0;
    grid-column: ${({ isMobile }) => (isMobile ? "auto" : "2 / 4")};
    justify-self: start;
  }
`;

/**
 * Componente StyledResultsFlights
 *
 * Grid para exibição dos resultados de voos.
 */
export const StyledResultsFlights = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "isMobile",
})<{ isMobile?: boolean }>`
  gap: ${({ theme }) => theme.spacing(4)};
  align-items: start;
  display: ${({ isMobile }) => (isMobile ? "flex" : "grid")};
  ${({ isMobile }) =>
    !isMobile &&
    `
      grid-template-columns: minmax(0, 0.75fr) minmax(0, 2fr) 300px;
    `}
`;

/**
 * Componente StyledFilterContainer
 *
 * Container para os filtros de resultados.
 */
export const StyledFilterContainer = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.extraLarge};
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  box-shadow: ${({ theme }) => theme.shadows.light.small};
  background-color: ${({ theme }) => theme.colors.white};
  min-width: ${({ theme }) => theme.spacing(20)};
  padding: ${({ theme }) => theme.spacing(2)};
`;

/**
 * Componente StyledFlightCardsContainer
 *
 * Container para os cards de resultados.
 */
export const StyledFlightCardsContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isMobile"].includes(prop as string),
})<{ isMobile?: boolean }>`
  min-width: ${({ theme, isMobile }) =>
    isMobile ? "100%" : theme.spacing(20)};
`;

export const StyledRigthAdsContainer = styled.div`
  min-width: ${({ theme }) => theme.spacing(20)};
`;
